import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postTransactionVerifyOtp } from "../api";
import { ErrorResponse } from "./useCreateTransaction";

export const useCreateTransactionVerifyOtp = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postTransactionVerifyOtp,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["TRANSACTION"] });
      router("/order-list");
      toast.success("Success Create Verify Otp");
    },
    onError: (error: ErrorResponse) => {
      const message =
        error?.response?.data?.message || "Failed to create transaction";
      toast.error(message);
    },
  });

  return { verifyOtp: mutate, isPending };
};
